export default __webpack_public_path__ + "static/media/sirius.f6b81a8f.png";